import { useTranslation } from 'libs/i18n'

export const useActionFilters = (isDeleteDisabled: boolean) => {
	const { t } = useTranslation()

	return [
		{
			id: 'actions',
			label: t('Actions'),
			placeholder: t('Default'),
			options: [
				{
					value: 'export',
					label: t('Export')
				},
				{
					value: 'delete',
					label: t('Delete'),
					isDisabled: isDeleteDisabled
				}
			]
		}
	]
}
